import type { User } from '@workos-inc/authkit-react'
import type { InternalIdentity } from 'src/interfaces/internalAuth'

/**
 * A person's name as WorkOS knows it, falling back to the internal record and then to the email.
 * Nothing is invented: a directory that supplies no name leaves the email standing on its own.
 */
export const buildUserDisplayName = (
  user: User | null,
  identity: InternalIdentity | null,
): string => {
  const firstName = user?.firstName ?? identity?.firstName
  const lastName = user?.lastName ?? identity?.lastName

  const fullName = [firstName, lastName]
    .filter((namePart) => {
      return Boolean(namePart)
    })
    .join(' ')

  return fullName || user?.email || identity?.email || ''
}

const MAX_BUTTON_NAME_LENGTH = 18

/** Keeps the top bar's button from growing with the name; the full value stays in the panel. */
export const truncateDisplayName = (displayName: string): string => {
  if (displayName.length <= MAX_BUTTON_NAME_LENGTH) {
    return displayName
  }

  return `${displayName.slice(0, MAX_BUTTON_NAME_LENGTH)}…`
}
